// extracted by mini-css-extract-plugin
export default {"attributeContainer":"EZll7b"};